export const isInIframe = () => window.self !== window.top;

export const isPaymentResultIframe = () =>
  window.location.pathname.match('/account/payment-result') && isInIframe();
